import React, { useState } from "react";
import axios from "axios";
import { Snackbar } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const Register = () => {
  const pathname = window.location.pathname;
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeForm, setActiveForm] = useState(
    pathname === "/register" ? true : false
  );
  const [formValues, setFormValues] = useState({
    user_type: "Mezun",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    program: "A",
    graduation_year: "",
    password: "",
    again_password: "",
    graduation_document: null,
  });
  const [companyFormValues, setCompanyFormValues] = useState({
    user_type: "Normal",
    company_name: "",
    email: "",
    phone: "",
    company_number: "A",
    website: "A",
    password: "",
    again_password: "",
    support_document: null,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false); // Snackbar açma durumu
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar mesajı
  const lisans = [
    "Acıbadem Mehmet Ali Aydınlar Üniversitesi - Biyomedikal Mühendisliği",
    "Afyon Kocatepe Üniversitesi - Biyomedikal Mühendisliği",
    "Ankara Üniversitesi - Biyomedikal Mühendisliği",
    "Bahçeşehir Üniversitesi - Biyomedikal Mühendisliği",
    "Başkent Üniversitesi - Biyomedikal Mühendisliği",
    "Beykent Üniversitesi - Biyomedikal Mühendisliği",
    "Biruni Üniversitesi - Biyomedikal Mühendisliği",
    "Çukurova Üniversitesi - Biyomedikal Mühendisliği",
    "Doğu Akdeniz Üniversitesi - Biyomedikal Mühendisliği",
    "Düzce Üniversitesi - Biyomedikal Mühendisliği",
    "Erciyes Üniversitesi - Biyomedikal Mühendisliği",
    "Fatih Sultan Mehmet Vakıf Üniversitesi - Biyomedikal Mühendisliği",
    "Işık Üniversitesi - Biyomedikal Mühendisliği",
    "İnönü Üniversitesi - Biyomedikal Mühendisliği",
    "İskenderun Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Arel Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Medipol Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Yeni Yüzyıl Üniversitesi - Biyomedikal Mühendisliği",
    "İstinye Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Bakırçay Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Demokrasi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Ekonomi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Katip Çelebi Üniversitesi - Biyomedikal Mühendisliği",
    "Karabük Üniversitesi - Biyomedikal Mühendisliği",
    "Kastamonu Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi (M.T.O.K) - Biyomedikal Mühendisliği",
    "Pamukkale Üniversitesi - Biyomedikal Mühendisliği",
    "Samsun Üniversitesi - Biyomedikal Mühendisliği",
    "Tekirdağ Namık Kemal Üniversitesi - Biyomedikal Mühendisliği",
    "TOBB Ekonomi Ve Teknoloji Üniversitesi - Biyomedikal Mühendisliği",
    "Uluslararası Kıbrıs Üniversitesi - Biyomedikal Mühendisliği",
    "Yakın Doğu Üniversitesi - Biyomedikal Mühendisliği",
    "Yeditepe Üniversitesi - Biyomedikal Mühendisliği",
    "Yıldız Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "Zonguldak Bülent Ecevit Üniversitesi - Biyomedikal Mühendisliği",
  ];

  const handleSetFileName = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const handleInputChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "user") {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    } else {
      setCompanyFormValues({
        ...companyFormValues,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    handleSetFileName(e);

    if (!file) {
      alert("Lütfen bir dosya seçin!");
      return;
    }

    console.log("Dosya Boyutu:", file.size);

    // Dosya boyutu kontrolü (örneğin, 10 MB sınırı)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      alert("Dosya boyutu 10MB'ı geçemez!");
      e.target.value = ""; // Dosya seçimini sıfırla
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const fileContent = reader.result.split(",")[1]; // Base64 içeriği alınır
      if (type === "user") {
        setFormValues((prev) => ({
          ...prev,
          graduation_document: fileContent, // Kullanıcı belgesi
        }));
      } else if (type === "company") {
        setCompanyFormValues((prev) => ({
          ...prev,
          support_document: fileContent, // Şirket belgesi
        }));
      }
    };

    reader.onerror = () => {
      console.error("Dosya okunurken bir hata oluştu.");
      alert("Dosya okunurken bir hata oluştu.");
    };

    reader.readAsDataURL(file);
  };

  const handleSend = async (event, type) => {
    setLoading(true);
    event.preventDefault();

    // Kullanıcı ya da Şirket Form Verilerini Ayarla
    const data = type === "user" ? formValues : companyFormValues;
    const requiredFields =
      type === "user"
        ? [
          "first_name",
          "last_name",
          "email",
          "phone",
          "program",
          "user_type",
          "password",
          "again_password",
          "graduation_year",
        ]
        : [
          "company_name",
          "email",
          "phone",
          "website",
          "company_number",
          "user_type",
        ];

    if (data.password.length !== 6) {
      alert("Şifreniz 6 karakter uzunluğunda olmalıdır");
      setLoading(false);
      return;
    }

    if (data.password !== data.again_password) {
      alert("Şifre ve Şifre tekrar uyuşmuyor!");
      setLoading(false);
      return;
    }

    if (!/^[1-9]\d{9}$/.test(data.phone)) {
      alert("Geçersiz numara. Numara formata uygun olmalıdır.");
      setLoading(false);
      return;
    }

    if (type === "user") {
      if (/^\d{4}$/.test(formValues.graduation_year) === false) {
        alert("Geçersiz yıl");
        setLoading(false);
        return;
      }

      const graduationYear = parseInt(formValues.graduation_year, 10);

      if (formValues.user_type === "Mezun") {
        if (graduationYear < 1980) {
          alert("Doğru bir mezuniyet yılı giriniz");
          setLoading(false);
          return;
        } else if (graduationYear > 2025) {
          alert("Doğru bir mezuniyet yılı giriniz");
          setLoading(false);
          return;
        }
      } else {
        if (graduationYear < 2025) {
          alert("Mezuniyet yılı 2025 veya sonrası olmalıdır.");
          setLoading(false);
          return;
        }
      }
    }

    // Doğrulama ve Uyarı
    const fileInputId = type === "user" ? "userFileInput" : "companyFileInput";
    const fileInput = document.getElementById(fileInputId);

    const maxFileSize = 10 * 1024 * 1024; // 10MB

    // Dosya Boyutunu Kontrol Et
    if (fileInput.files[0].size > maxFileSize) {
      setSnackbarMessage("Dosya boyutu 10MB'den büyük olamaz!");
      setOpenSnackbar(true);
      console.log("Dosya boyutu fazla");
      setLoading(false);
      return;
    }

    // Tüm zorunlu alanlar ve dosya kontrolü
    if (requiredFields.some((field) => !data[field])) {
      setSnackbarMessage("Tüm alanları doldurmalısınız!");
      setOpenSnackbar(true);
      requiredFields.forEach((field) => {
        if (!data[field]) console.log(`Eksik Alan: ${field}`);
      });
      setLoading(false);
      return;
    }

    // Dosya seçimi kontrolü
    if (!fileInput || !fileInput.files[0]) {
      setSnackbarMessage("Dosya seçilmedi! Lütfen bir dosya seçiniz ");
      setOpenSnackbar(true);
      console.log("Dosya seçilmemiş!");
      setLoading(false);
      return;
    }

    // FormData Hazırlığı
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => formData.append(key, value));
    formData.append(
      type === "user" ? "graduation_document" : "support_document",
      fileInput.files[0]
    );

    // Konsola gönderilecek veriyi yazdırma
    console.log("Form Verileri:", data); // Form verileri
    console.log("Gönderilen Dosya:", fileInput.files[0]); // Yüklenen dosya

    const sendEmail = data.email;
    try {
      // Endpoint URL'si
      const url =
        type === "user"
          ? "https://kariyer.biyomed.net/api/register/person"
          : "https://kariyer.biyomed.net/api/register/company";

      // POST İsteği
      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      //Email Gönderme
      await axios.post(
        "https://kariyer.biyomed.net/api/email/sendRegister",
        sendEmail,
        {}
      );

      console.log("Kayıt Başarılı:", response.data);

      alert(
        "Kayıt Başarılı! Mail kutunuzu kontrol ediniz. Ayrıca, e-postanızı bulamazsanız lütfen spam veya gereksiz (junk) klasörünü de kontrol ediniz."
      );
      setLoading(false);
      window.location.href = "/login";
    } catch (error) {
      // Hata Yönetimi
      console.error("Kayıt Hatası:", error);
      alert(error.response?.data?.message || "Bir hata oluştu.");
      setLoading(false);
    }
  };

  const handleClick = (event) => {
    setActiveForm(!activeForm);
    event.preventDefault();
  };
  return (
    <div className="register_section">
      {/* register_form_wrapper */}
      <div className="register_tab_wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <div role="tabpanel">
                {/* Nav tabs */}
                <ul id="tabOne" className="nav register-tabs">
                  <li
                    className={`${activeForm ? "active" : ""}`}
                    style={
                      activeForm ? { pointerEvents: "none", color: "gray" } : {}
                    }
                  >
                    <a href="/" onClick={handleClick}>
                      Kişi
                      <br />
                      <span>İş/Staj arıyorum</span>
                    </a>
                  </li>
                  <li
                    className={`${activeForm ? "" : "active"}`}
                    style={
                      activeForm ? {} : { pointerEvents: "none", color: "gray" }
                    }
                  >
                    <a href="/" onClick={handleClick}>
                      Firma/Sağlık Kuruluşu <br />{" "}
                      <span>Biyomedikal mühendisi arıyorum</span>
                    </a>
                  </li>
                </ul>
                {/* Tab panes */}
                <div className="tab-content">
                  <div
                    className={`tab-pane fade register_left_form ${activeForm ? "active in" : ""
                      }`}
                    id="contentOne-1"
                  >
                    <div className="jp_regiter_top_heading">
                      <p>Tüm alanların doldurulması zorunludur</p>
                    </div>
                    <div className="row">
                      {/*USER*/}
                      <form
                        action="#"
                        data-toggle="validator"
                        onSubmit={(e) => handleSend(e, "user")}
                      >
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <select
                            onChange={(e) => handleInputChange(e, "user")}
                            name="user_type"
                            aria-label="Kullanıcı Türünü Seçiniz"
                            className="form-select"
                            required
                          >
                            <option value="" disabled selected>
                              Kullanıcı Türünü Seçiniz
                            </option>
                            <option value="Mezun">Mezun</option>
                            <option value="Ogrenci">Öğrenci</option>
                          </select>
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <select
                            onChange={(e) => handleInputChange(e, "user")}
                            name="program"
                            className="form-select"
                            required
                          >
                            <option value="" disabled selected>
                              Lisans Programını Seçiniz
                            </option>
                            {lisans.map((universite, index) => (
                              <option key={index} value={universite}>
                                {universite}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="first_name"
                            onChange={(e) => handleInputChange(e, "user")}
                            placeholder="Ad"
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="last_name"
                            onChange={(e) => handleInputChange(e, "user")}
                            type="text"
                            placeholder="Soyad"
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="email"
                            onChange={(e) => handleInputChange(e, "user")}
                            placeholder="Email"
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="phone"
                            onChange={(e) => handleInputChange(e, "user")}
                            type="text"
                            placeholder="Telefon: Başında sıfır olmadan giriniz örn(5xx-xxx-xxxx) "
                            required
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="password"
                            onChange={(e) => handleInputChange(e, "user")}
                            type="password"
                            placeholder="Şifrenizi giriniz "
                            required
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="again_password"
                            onChange={(e) => handleInputChange(e, "user")}
                            type="password"
                            placeholder="Şifre tekrar"
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div
                          className="form-group col-md-6 col-sm-6 col-xs-12 custom_input"
                          required
                        >
                          <label>
                            Lisans Mezuniyet Yılı/Tahmini Lisans Mezuniyet Yılı
                          </label>
                          <input
                            style={{ width: "50%", marginTop: -5 }}
                            type="text"
                            name="graduation_year"
                            onChange={(e) => handleInputChange(e, "user")}
                            placeholder={
                              formValues.user_type === "Mezun"
                                ? "Mezuniyet Yılı Giriniz"
                                : "Tahmini Mezuniyet Yılı"
                            }
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div
                          className="form-group col-md-6 col-sm-6 col-xs-12 custom_input"
                          required
                        >
                          <label htmlFor="cv">
                            Öğrenci/Mezuniyet belgesi yükleyiniz (Maks 10MB)
                          </label>
                          <div className="custom-input">
                            <label
                              htmlFor="userFileInput"
                              style={{
                                display: "inline-block",
                                backgroundColor: formValues.graduation_document
                                  ? "green"
                                  : "#00b5e4",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <i className="fa fa-upload" /> &nbsp;
                              {formValues.graduation_document
                                ? "Belge Yüklendi"
                                : "Belge Yükle"}
                            </label>

                            <input
                              type="file"
                              name="graduation_document"
                              accept=".pdf"
                              onChange={(e) => handleFileChange(e, "user")}
                              id="userFileInput"
                              style={{ display: "none" }}
                            />

                            {fileName && (
                              <p
                                style={{
                                  marginLeft: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                {fileName}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div className="check-box text-center">
                            <input
                              type="checkbox"
                              name="shipping-option"
                              id="account-option_1"
                              required
                            />
                            <label
                              style={{ marginLeft: 10 }}
                              htmlFor="account-option_1"
                            >
                              <a
                                href="/terms-and-privacy"
                                className="check_box_anchr"
                              >
                                Kullanım koşullarını{" "}
                              </a>
                              okudum onaylıyorum
                            </label>
                          </div>
                          <div className="check-box text-center">
                            <input
                              type="checkbox"
                              name="shipping-option"
                              id="account-option_1"
                              required
                            />
                            <label
                              style={{ marginLeft: 10 }}
                              htmlFor="account-option_1"
                            >
                              {" "}
                              <a
                                href="https://www.biyomed.org.tr/kvkk-metni"
                                className="check_box_anchr"
                              >
                                KVKK
                              </a>{" "}
                              metnini okudum onaylıyorum
                            </label>
                          </div>
                        </div>
                        <div className="login_btn_wrapper register_btn_wrapper login_wrapper ">
                          <button
                            type="submit"
                            className="btn btn-primary login_btn"
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress size={24} color="inherit" />
                            ) : (
                              "Kayit Ol"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="login_message">
                      <p>
                        Zaten üye misin? <a href="/login">Giriş yap</a>
                      </p>
                    </div>
                    {/* Snackbar for error message */}
                    <Snackbar
                      open={openSnackbar}
                      autoHideDuration={3000}
                      onClose={() => setOpenSnackbar(false)}
                      message={snackbarMessage}
                    />
                  </div>

                  <div
                    className={`tab-pane fade register_left_form ${activeForm ? "" : "active in"
                      }`}
                    id="contentOne-2"
                  >
                    <div className="jp_regiter_top_heading">
                      <p>Tüm alanların doldurulması zorunludur</p>
                    </div>
                    <div className="row clearfix">
                      {/*COMPANY*/}
                      <form
                        action="#"
                        data-toggle="validator"
                        onSubmit={(e) => handleSend(e, "company")}
                      >
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="company_name"
                            onChange={(e) => handleInputChange(e, "company")}
                            placeholder="Firma/Sağlık Kuruluşu Adı"
                            required=""
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="company_number"
                            onChange={(e) => handleInputChange(e, "company")}
                            placeholder="Vergi No/ÜTS Firma No"
                            required=""
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="email"
                            name="email"
                            onChange={(e) => handleInputChange(e, "company")}
                            placeholder="E-posta"
                            required=""
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="phone"
                            onChange={(e) => handleInputChange(e, "company")}
                            placeholder="Telefon: Başında sıfır olmadan giriniz örn(5xx-xxx-xxxx) "
                            required=""
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="password"
                            onChange={(e) => handleInputChange(e, "company")}
                            type="password"
                            placeholder="Şifrenizi giriniz "
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            type="text"
                            name="website"
                            onChange={(e) => handleInputChange(e, "company")}
                            placeholder="Websayfası Linki"
                            required=""
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-xs-12">
                          <input
                            name="again_password"
                            onChange={(e) => handleInputChange(e, "company")}
                            type="password"
                            placeholder="Şifre tekrar"
                            required
                          />
                        </div>
                        {/*Form Group*/}
                        <div
                          className="form-group col-md-6 col-sm-6 col-xs-12 custom_input"
                          required
                        >
                          <label htmlFor="cv">
                            İlgili kuruluş adına işlem yapmaya yetkili
                            olduğunuzu gösteren destekleyici döküman yükleyiniz
                          </label>
                          <div className="custom-input">
                            <label
                              htmlFor="companyFileInput"
                              style={{
                                display: "inline-block",
                                backgroundColor: companyFormValues.support_document ? "green" : "#00b5e4",
                                padding: "10px 15px",
                                borderRadius: "5px",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              <i className="fa fa-upload" /> &nbsp;
                              {companyFormValues.support_document ? "Belge Yüklendi" : "Belge Yükle"}
                            </label>

                            <input
                              type="file"
                              name="support_document"
                              accept=".pdf"
                              onChange={(e) => handleFileChange(e, "company")}
                              id="companyFileInput"
                              required
                              style={{ display: "none" }} // Gözükmesin ama tıklanabilir olsun
                            />

                            {fileName && (
                              <p style={{ marginLeft: "10px", fontWeight: "bold" }}>{fileName}</p>
                            )}
                          </div>
                        </div>

                        {/*Form Group*/}

                        <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div className="check-box text-center">
                            <input
                              type="checkbox"
                              name="shipping-option"
                              id="account-option_1"
                              required
                            />
                            <label
                              style={{ marginLeft: 10 }}
                              htmlFor="account-option_1"
                            >
                              <a
                                href="/terms-and-privacy"
                                className="check_box_anchr"
                              >
                                Kullanım koşullarını{" "}
                              </a>
                              okudum onaylıyorum
                            </label>
                          </div>
                          <div className="check-box text-center">
                            <input
                              type="checkbox"
                              name="shipping-option"
                              id="account-option_1"
                              required
                            />
                            <label
                              style={{ marginLeft: 10 }}
                              htmlFor="account-option_1"
                            >
                              {" "}
                              <a
                                href="https://www.biyomed.org.tr/kvkk-metni"
                                className="check_box_anchr"
                              >
                                KVKK
                              </a>{" "}
                              metnini okudum onaylıyorum
                            </label>
                          </div>
                        </div>
                        <div className="login_btn_wrapper register_btn_wrapper login_wrapper">
                          <button
                            type="submit"
                            className="btn btn-primary login_btn"
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress size={24} color="inherit" />
                            ) : (
                              "Kayit Ol"
                            )}
                          </button>
                          {/* <a href="javascript:;" class="btn btn-primary login_btn"> register </a> */}
                        </div>
                      </form>
                    </div>
                    <div className="login_message">
                      <p>
                        Zaten üye misin? <a href="/login">Giriş yap</a>
                      </p>
                    </div>
                    <Snackbar
                      open={openSnackbar}
                      autoHideDuration={3000}
                      onClose={() => setOpenSnackbar(false)}
                      message={snackbarMessage}
                    />
                  </div>
                </div>
                <p className="btm_txt_register_form">
                  Genel/paylaşılan bir bilgisayar kullanıyorsanız hesabınıza
                  yetkisiz erişimi engellemek için oturumunuzu kapatmanızı
                  öneririz
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
